import type { Cache } from '@app/utils/cache'

import { createThunk } from '@app/store/thunk'

export function getServerCache() {
  return createThunk((_dispatch, _getState, context) => context.lookup<Cache>(ServerCacheSymbol))
}
export function setServerCache(value: Cache) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(ServerCacheSymbol, value))
}

const ServerCacheSymbol = Symbol('ServerCache')
